import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Auth } from '@aws-amplify/auth';
import MSPLogin from './components/MSPLogin';
import MSPDashboard from './components/MSPDashboard';
import MSPProtectedRoute from './components/MSPProtectedRoute';
import { getMSPConfig } from './utils/mspApi';
import toastr from 'toastr';

const MSPApp = ({ mspSlug }) => {
  const finalMspSlug = mspSlug || process.env.REACT_APP_MSP_SLUG;
  const [mspConfig, setMspConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadMSPConfig = async () => {
      try {
        const config = await getMSPConfig(finalMspSlug);
        setMspConfig(config);
        
        // Apply MSP branding
        if (config.branding) {
          document.title = `${config.name} - Cloud Management Portal`;
          if (config.branding.primaryColor) {
            document.documentElement.style.setProperty('--primary-color', config.branding.primaryColor);
          }
        }
      } catch (error) {
        console.error('MSP not found:', error);
        toastr.error('MSP portal not found');
      } finally {
        setLoading(false);
      }
    };

    if (finalMspSlug) {
      loadMSPConfig();
    } else {
      console.error('No MSP slug provided');
      setLoading(false);
    }
  }, [finalMspSlug, mspSlug]); // ✅ FIX

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!mspConfig) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="text-center">
          <h3>MSP Portal Not Found</h3>
          <p>The requested MSP portal does not exist.</p>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        {/* MSP Authentication */}
        <Route element={<MSPProtectedRoute isAuthPage={true} mspConfig={mspConfig} />}>
          <Route path="/login" element={<MSPLogin mspConfig={mspConfig} />} />
        </Route>

        {/* MSP Protected Pages */}
        <Route element={<MSPProtectedRoute isAuthPage={false} mspConfig={mspConfig} />}>
          <Route path="/dashboard/*" element={<MSPDashboard mspConfig={mspConfig} />} />
        </Route>

        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );
};

export default MSPApp;
